// /finance — 财务模块父布局
// v1.31 4 子页: /finance (dashboard) | /finance/ar | /finance/profit | /finance/tax-refund | /finance/cashflow
// 设计: 顶部 tab nav, 移动端折叠
import { Link, Outlet, createFileRoute, useLocation } from '@tanstack/react-router';
import { Icon } from '../components/Icon';

export const Route = createFileRoute('/finance')({
  component: FinanceLayout,
});

const TABS: { to: string; label: string; icon: string; match: 'exact' | 'prefix' }[] = [
  { to: '/finance', label: '概览', icon: 'layout-dashboard', match: 'exact' },
  { to: '/finance/ar', label: '应收', icon: 'circle-dollar-sign', match: 'prefix' },
  { to: '/finance/profit', label: '利润', icon: 'bar-chart-3', match: 'prefix' },
  { to: '/finance/tax-refund', label: '退税', icon: 'receipt', match: 'prefix' },
  { to: '/finance/cashflow', label: '现金流', icon: 'trending-up', match: 'prefix' },
];

function FinanceLayout() {
  const location = useLocation();

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl sm:text-2xl font-semibold mb-1">财务</h1>
        <p className="text-ink-3 text-xs sm:text-sm">v1.31 · 4 模块一站式</p>
      </div>

      {/* Tab nav — 移动端横向滚动 */}
      <div className="border-b border-line mb-5 -mx-1">
        <nav className="flex gap-1 overflow-x-auto px-1" aria-label="财务子模块">
          {TABS.map((tab) => {
            const active =
              tab.match === 'exact'
                ? location.pathname === tab.to
                : location.pathname === tab.to || location.pathname.startsWith(`${tab.to}/`);
            return (
              <Link
                key={tab.to}
                to={tab.to}
                className={`
                  inline-flex items-center gap-2 px-3 py-2 text-sm font-medium whitespace-nowrap
                  border-b-2 transition-colors
                  ${
                    active
                      ? 'border-accent text-accent'
                      : 'border-transparent text-ink-2 hover:text-ink hover:border-line'
                  }
                `}
              >
                <Icon name={tab.icon} size="sm" className={active ? 'text-accent' : 'text-ink-3'} />
                {tab.label}
              </Link>
            );
          })}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
